import api from '@/helpers/api_helper';
import qs from 'qs';
import { apiUrls } from '@/constant/configure';

export type OrderedPaymentInfo = {
    totalCharge: number;
    paymentMethod: string;
    paymentInstallment: string;
};

export type OrderedPriceInfo = {
    productCharge: number;
    discountCharge: number;
    shippingCost: number;
    islandMountainShippingCost?: number;
    usedMileage?: number;
    totalCharge: number;
};

export type OrderedShippingAddressInfo = {
    recipientName: string;
    recipientPhoneNumber: string;
    recipientAddress: string;
    shippingRequestMessage?: string;
    mallRequestMessage?: string;
    recipientAddressDetail: string;
    recipientPostCode: string;
};

export type OrderedDeliveryInfo = {
    shippingMethod: string;
    carriersName: string;
    invoiceNumber: string;
};

export type OrderedProductItem = {
    productId: string;
    representProductId: string;
    representProductName: string;
    productOptionsName: string;
    representProductImage: string;
    productPrice: number;
    discountMethod: 'won' | 'percent';
    discountValue: number;
    productAmount: number;
    totalProductPrice: number;
    isIssue: boolean;
    productCode: string;
    totalCharge: number;
    shippingCost: number;
};

export interface OrderItem {
    mallOrderId: string;
    mallOrderNumber: string;
    mallOrderGroupId: string;
    mallOrderGroupNumber: string;
    orderStateCode: number;
    orderedAt: string;
    productInfo: OrderedProductItem;
    priceInfo: OrderedPriceInfo;
    paymentInfo: OrderedPaymentInfo;
    deliveryInfo?: OrderedDeliveryInfo;
    extraChargePaymentInfo?: {
        totalCount: number;
        totalCharge: number;
    };
    shippingAddressInfo?: OrderedShippingAddressInfo;
    ordererInfo: {
        ordererName: string;
        ordererPhoneNumber: string;
        ordererEmail: string;
    };
}

export interface OrderListResponse {
    list: OrderItem[];
    total: number;
}

export interface GetOrderListParams {
    limit: number;
    offset: number;
    searchKey?: 'keyword' | 'tag';
    searchValue?: string;
    startDate?: string;
    endDate?: string;
    order_state_type?: any;
    refund_type?: any;
    orderer_name?: any;
    recipient_name?: any;
    order_number?: any;
    // order_id?: any;
    // order_group_id?: any;
}

export const getOrderList = async (mallId: string, queryParams?: GetOrderListParams): Promise<OrderListResponse> => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;

        queryParams = {
            offset: offset,
            limit: limit,
            // ...queryParams,
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getOrderList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const getShippingList = async (mallId: string, queryParams?: GetOrderListParams): Promise<OrderListResponse> => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        let order_state_type = '';
        if ((queryParams?.order_state_type?.in || []).length === 0) {
            order_state_type = '주문확인완료,취소요청거절,배송대기,배송중,배송완료,구매확정';
        } else {
            order_state_type = (queryParams?.order_state_type?.in || []).join(',');
        }
        let recipient_name = '';
        if (!!queryParams?.orderer_name?.like) {
            recipient_name = queryParams?.orderer_name;
        }
        // let order_id = ''
        // let order_group_id = ''
        // if (!!queryParams?.order_number?.like) {
        //     order_group_id = queryParams?.order_number?.like
        //     order_id = queryParams?.order_number?.like
        // }
        queryParams = {
            ...queryParams,
            offset: offset,
            limit: limit,
            order_state_type,
            recipient_name,
            // order_id,
            // order_group_id
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getOrderList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order-group/delivery${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const getReturningOrderList = async (
    mallId: string,
    queryParams?: GetOrderListParams,
): Promise<OrderListResponse> => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;

        queryParams = {
            offset: offset,
            limit: limit,
            ...queryParams,
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getOrderList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order/return${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const getIssueOrderList = async (mallId: string, queryParams?: GetOrderListParams) => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        let order_state_type = '';
        const defaultFilter = [
            '구매취소',
            '주문취소',
            '취소요청',
            '취소요청거절',
            '취소진행중',
            '반품요청',
            '반품요청',
            '교환진행중',
            '반품요청승인',
            '반품진행중',
            '반품거절',
            '환불진행중',
            '반품완료',
            '반품완료',
            '교환완료',
            '환불완료',
        ];
        if ((queryParams?.order_state_type?.in || []).length === 0) {
            order_state_type = defaultFilter.join(',');
        } else {
            order_state_type = (queryParams?.order_state_type?.in || []).join(',');
        }
        let recipient_name = '';
        if (!!queryParams?.orderer_name?.like) {
            recipient_name = queryParams?.orderer_name;
        }
        // let order_id = ''
        // let order_group_id = ''
        // if (!!queryParams?.order_number?.like) {
        //     order_group_id = queryParams?.order_number?.like
        //     order_id = queryParams?.order_number?.like
        // }
        queryParams = {
            ...queryParams,
            offset: offset,
            limit: limit,
            order_state_type,
            recipient_name,
            // order_id,
            // order_group_id
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getIssueList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order-group/return${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};
export const getRefundOrderList = async (mallId: string, queryParams?: GetOrderListParams) => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        let refund_type = 'ALL';
        if (!!(queryParams?.refund_type === '부분환불')) {
            refund_type = 'PARTIAL_REFUND';
        }
        if (!!(queryParams?.refund_type === '전체환불')) {
            refund_type = 'ALL_REFUND';
        }
        let recipient_name = '';
        if (!!queryParams?.orderer_name?.like) {
            recipient_name = queryParams?.orderer_name;
        }
        // let order_id =''
        // let order_group_id =''
        // if (!!queryParams?.order_number?.like) {
        //     order_group_id = queryParams?.order_number?.like
        //     order_id = queryParams?.order_number?.like
        // }

        queryParams = {
            ...queryParams,
            offset: offset,
            limit: limit,
            refund_type,
            // order_id,
            // order_group_id,
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getRefundList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order-group/refund${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const getReturnRequestInfo = async (mallId: string, orderId: string) => {
    try {
        return await api.get(`/mall/${mallId}/order/${orderId}/return-request`).then((r) => {
            return r.data?.cancelOrderInfo || r.data || {};
        });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const respondReturningRequest = async (
    mallId: string,
    orderId: string,
    action: 'approval' | 'refusal' = 'approval',
) => {
    try {
        if (action === 'refusal') {
            await api.post(`/mall/${mallId}/order/${orderId}/return-request/refusal`);
        } else {
            await api.post(`/mall/${mallId}/order/${orderId}/return-request/approval`);
        }
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const refuseReturn = async (mallId: string, orderId: string) => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/return/refusal`);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const postRefundConfirm = async (mallId: string, orderId: string, amount?: number) => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/return/complete`, !!amount ? { refundAmount: amount } : {});
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const getExtraChargeList = async (mallId: string, orderId: string) => {
    try {
        return await api.get(`/mall/${mallId}/order/${orderId}/extra-charge`).then((r) => {
            return r.data?.extraChargeInfo || r.data || [];
        });
    } catch (e: any) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            if (e.status === 404) return [];
            throw e;
        }
    }
};

export type PostExtraChargeData = {
    remark: string;
    extraCharge: number;
};

export const postExtraCharge = async (mallId: string, orderId: string, data: PostExtraChargeData) => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/extra-charge`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const withdrawExtraCharge = async (mallId: string, orderId: string) => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/extra-charge/withdraw`);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export interface OrderGroupItem {
    mallOrderGroupId: string;
    mallOrderGroupNumber: string;
    mallSubOrderList: [
        {
            mallOrderId: string;
            mallOrderNumber: string;
            orderStateCode: number;
            deliveryInfo?: OrderedDeliveryInfo;
            productInfo: OrderedProductItem;
        },
    ];
    orderedAt: string;
    ordererInfo: {
        ordererName: string;
        ordererEmail: string;
        ordererPhoneNumber: string;
    };
    shippingAddressInfo: OrderedShippingAddressInfo;
    priceInfo: OrderedPriceInfo;
    paymentInfo: OrderedPaymentInfo;
    extraChargePaymentInfo?: {
        totalCount: number;
        totalCharge: number;
    };
    mallId: string;
    totalIssueCount: number;
}

export interface OrderGroupListResponse {
    list: OrderGroupItem[];
    total: number;
}

export interface GetOrderGroupListParams {
    limit: number;
    offset: number;
    searchKey?: 'keyword' | 'tag';
    searchValue?: string;
    startDate?: string;
    endDate?: string;
    order_state_type?: any;
    orderer_name?: any;
    recipient_name?: any;
    order_number?: any;
    // order_id?: any;
    // order_group_id?: any;
}
export const getOrderGroupList = async (
    mallId: string,
    queryParams?: GetOrderGroupListParams,
): Promise<OrderGroupListResponse> => {
    try {
        const offset = queryParams?.offset || 0;
        const limit = queryParams?.limit || 15;
        let recipient_name = '';
        let order_state_type = '';
        if ((queryParams?.order_state_type?.in || []).length === 0) {
            order_state_type = '결제대기,결제완료,주문확인완료,취소요청거절';
        } else {
            order_state_type = (queryParams?.order_state_type?.in || []).join(',');
        }
        if (!!queryParams?.orderer_name?.like) {
            recipient_name = queryParams?.orderer_name;
        }

        // let order_id = ''
        // let order_group_id = ''
        // if (!!queryParams?.order_number?.like) {
        //     order_group_id = queryParams?.order_number?.like || ''
        //     order_id = queryParams?.order_number?.like || ''
        // }

        queryParams = {
            ...queryParams,
            offset: offset,
            limit: limit,
            order_state_type: order_state_type,
            recipient_name,
            // order_id,
            // order_group_id
        };

        const queryStr = qs.stringify(queryParams);
        console.log('getOrderGroupList-queryStr', queryStr);

        return await api.get(`/mall/${mallId}/order-group${!!queryStr ? `?${queryStr}` : ''}`).then((r) => {
            return {
                list: r.data?.orderGroupList || r.data?.orderList || [],
                total: r.data?.totalCount || 0,
            };
        });
    } catch (e) {
        throw e;
    }
};

export const confirmOrderGroup = async (mallId: string, orderGroupId: string) => {
    try {
        await api.post(`/mall/${mallId}/order-group/${orderGroupId}/confirmation`);

        return true;
    } catch (e) {
        throw e;
    }
};
export const confirmOrder = async (mallId: string, orderId: string) => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/confirmation`, {}, {});

        return true;
    } catch (e) {
        throw e;
    }
};

export const cancelOrderGroup = async (mallId: string, orderGroupId: string, cancelReason: string = 'SOLD_OUT') => {
    try {
        await api.post(`/mall/${mallId}/order-group/${orderGroupId}/cancel`, { cancelReason });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};
export const cancelOrder = async (mallId: string, orderId: string, cancelReason: string = 'SOLD_OUT') => {
    try {
        await api.post(`/mall/${mallId}/order/${orderId}/cancel`, { cancelReason }, {});
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const getOrderCancelInfo = async (mallId: string, orderGroupId: string) => {
    try {
        return await api.get(`/mall/${mallId}/order-group/${orderGroupId}/cancel`).then((r) => {
            return (
                r.data?.cancelOrderInfo || {
                    issueState: '',
                    remark: '',
                    isClosed: true,
                }
            );
        });
    } catch (e: any) {
        if (e.data?.placeHolder || e.placeHolder) {
            return {
                remark: e.data?.placeHolder || e.placeHolder,
                isClosed: true,
            };
        }

        throw e;
    }
};

export const confirmOrderCancelByGroupOrder = async (
    mallId: string,
    orderGroupId: string,
    action: 'refusal' | 'approval' = 'approval',
) => {
    try {
        if (action === 'refusal') {
            await api.post(`/mall/${mallId}/order-group/${orderGroupId}/cancel/refusal`);
        } else {
            await api.post(`/mall/${mallId}/order-group/${orderGroupId}/cancel/approval`);
        }
    } catch (e: any) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};
export const confirmOrderCancelByOrder = async (
    mallId: string,
    orderGroupId: string,
    action: 'refusal' | 'approval' = 'approval',
) => {
    try {
        if (action === 'refusal') {
            await api.post(`/mall/${mallId}/order/${orderGroupId}/cancel/refusal`, {}, {});
        } else {
            await api.post(`/mall/${mallId}/order/${orderGroupId}/cancel/approval`, {}, {});
        }
    } catch (e: any) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};

export const registerShippingInvoice = async (
    mallId: string,
    orderId: string,
    data: {
        carriersId: string;
        invoiceType: string;
        shippingMethod: string;
        invoiceNumber: string;
    },
) => {
    try {
        await api.patch(`/mall/${mallId}/order/${orderId}/invoice`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};
export const registerOrderGroupShippingInvoice = async (
    mallId: string,
    orderGroupId: string,
    data: {
        carriersId: string;
        invoiceType: string;
        shippingMethod: string;
        invoiceNumber: string;
    },
) => {
    try {
        await api.patch(`/mall/${mallId}/order-group/${orderGroupId}/invoice`, data);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};

export const getCarriers = async (): Promise<
    {
        id: string;
        name: string;
        tel: string;
    }[]
> => {
    try {
        return await api
            .get(`/carriers/info`, {
                baseURL: apiUrls.mall_common,
            })
            .then((r) => {
                return r.data?.invoiceInfo || [];
            });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};

export const getDeliveryInfo = async (carriersId: string, invoiceNumber: string) => {
    try {
        return await api
            .get(`/carriers/${carriersId}/invoice/${invoiceNumber}`, {
                baseURL: apiUrls.mall_common,
            })
            .then((r) => {
                return r.data?.invoiceInfo || r?.data || {};
            });
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        }

        throw e;
    }
};

export const forcedCompleteDeliveryOrder = async (
    mallId: string,
    orderId: string,
    deliveryType?: 'delivery' | 'exchange',
) => {
    try {
        deliveryType = deliveryType || 'delivery';

        if (deliveryType === 'delivery') {
            await api.post(`/mall/${mallId}/order/${orderId}/delivery-complete`);
        } else {
            await api.post(`/mall/${mallId}/order/${orderId}/exchange/complete`);
        }
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const uploadInvoiceNumberFile = async (mallId: string, file: any) => {
    try {
        return await api.post(`/mall/${mallId}/invoice/upload`, file).then((r) => r);
    } catch (error) {
        throw error;
    }
};

export type PartialRefundOrderGroupPayload = {
    refundAmount: number;
    refundReason: string;
    virtualAccount?: {
        bankCode: string;
        accountNumber: string;
        holderName: string;
    };
};
export const requestPartialRefundOrder = async (
    mallId: string,
    orderId: string,
    payload: PartialRefundOrderGroupPayload,
) => {
    try {
        if (!mallId || !orderId || !payload) {
            console.error('필수값 누락');
            return;
        }
        await api.post(`/mall/${mallId}/order/${orderId}/partial-refund`, payload);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};

export const updateDeliveryState = async (mallId: string) => {
    try {
        if (!mallId) return;
        return await api.post(`/mall/${mallId}/waiting-webhook/complete`).then((r) => r);
    } catch (e) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            throw e;
        }
    }
};
export type RealTimeOrderType = {
    totalAmount: {
        orderCount: number;
        proceedOrderCount: number;
        proceedProductCount: number;
        productCount: number;
    };
    productAmountList: {
        completedAmount: number;
        inventory: number;
        optionName: string;
        proceedAmount: number;
        waitingAmount: number;
        // sellerId: string;
        // sellerName: string;
        sellerInfo: {
            sellerId: string;
            sellerName: string;
            sellerImage: string;
        };
        productName: string;
        rowId: string;
    }[];
};
export const getRealtimeOrderData = async (mallId: string): Promise<RealTimeOrderType> => {
    try {
        return await api.get(`/mall/${mallId}/order-group/orders/inventory`).then((r) => {
            const returnData = {
                productAmountList: r.data?.productAmountList || [],
                totalAmount: {
                    orderCount: r.data?.orderCount || 0,
                    proceedOrderCount: r.data?.proceedOrderCount || 0,
                    proceedProductCount: r.data?.proceedProductCount || 0,
                    productCount: r.data?.productCount || 0,
                },
            };
            return returnData;
        });
    } catch (e: any) {
        if (typeof e === 'string') {
            throw {
                message: e,
            };
        } else {
            if (e?.place_holder || e?.data?.place_holder) {
                throw {
                    ...e,
                    placeHolder: e.data?.place_holder || e.place_holder,
                };
            } else {
                throw e;
            }
        }
    }
};
